import { styled } from "@mui/material";

import { Box } from "shipnow-mercurio";

const Wrapper = styled(Box)((props) => ({
  margin: props.center ? "auto" : "0",
  width: "150px",
}));

export const Styles = {
  Wrapper,
};
